<template>
  <div class="main-container requests-table-height">
    <vk-modal :show.sync="dialogVisible">
      <vk-modal-close @click="dialogVisible = false"></vk-modal-close>
      <vk-modal-title>Payment Options</vk-modal-title>
      <hr />
      <div style="flex: 1; display: flex-flow: column; justify-content: center; padding: 10px;">
        <!-- {{paymentMeta}} -->
        <div v-for="(feePay,index_ ) in Object.keys(feePayable)" :key="`${index_}`">
          <label style="text-transform: capitalize;">
            <input
              v-model="selectedPayments[feePay]"
              class="uk-checkbox"
              type="checkbox"
              :disabled="feePay == 'setup'"
              checked
            />
            <!-- {{feePayable[feePay]}} -->
            {{feePay }} {{feePay != "monthly"?"Fee":"Subscription"}} - ₦{{feePayable[feePay]['total']}} &nbsp; {{feePayable[feePay]['discount'] > 0? `(Discount: ₦${feePayable[feePay]['discount']}) `:''}}
          </label>
        </div>
        <h2 class="text-center">Total: ₦{{ calculatedAmount }}</h2>
        <!-- <el-checkbox v-model="checked2" label="Option2" border></el-checkbox> -->
      </div>
      <div class="text-center">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <Rave
          style="display: none;"
          :id="`paymentBtn_`"
          :is-production="false"
          :text="raveBtnText"
          style-class="btn btn-primary"
          :email="formData.email"
          :amount="calculatedAmount"
          :reference="reference"
          :rave-key="raveKey"
          :callback="callback"
          :metadata="[{metaname: 'requestInfo', metavalue:JSON.stringify(paymentMeta)}]"
          paymentOptions="card,barter,account,ussd"
          :close="close"
          currency="NGN"
          :customerFirstname="formData.firstname"
          :customerLastname="formData.lastname"
          :customerPhone="formData.phonenumber"
        ></Rave>
        <el-button type="primary" @click="triggerPayment">Continue</el-button>
        <!-- <can I="am" a="finance">
            <button class="btn btn-primary" @click="submitRequest">Approve inventory request</button>
        </can>-->
      </div>
    </vk-modal>

    <div style="width: 100%;">
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :lineNumbers="true"
        :columns="columns"
        :rows="deviceRequests"
        :search-options="{enabled: true,
                externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
      >
        <template slot="table-row" slot-scope="props">
          <!-- {{props.row}} -->
          <span
            v-if="props.column.field == 'full_name'"
          >{{ props.row.user? `${props.row.user['firstName'] } ${ props.row.user['lastName']}`:'--' }}</span>
          <span
            v-if="props.column.field == 'email'"
          >{{ props.row.user? `${props.row.user['email'] } ` :'--' }}</span>
          <span
            v-if="props.column.field == 'user.phone'"
          >{{ props.row.user? `${props.row.user['phoneNumber'] } ` :'--' }}</span>
          <span
            v-if="props.column.field == 'deviceType.name'"
          >{{ props.row.deviceType? `${props.row.deviceType['name'] } ` :'--' }}</span>
          <span v-if="props.column.field == 'deviceType.paymentModel'">
            <!-- {{props.row}} -->
            {{ props.row.paymentModel }}
          </span>
          <!-- <span v-if="props.column.field == 'order.paymentAmount'">
            {{ calculatePaymentAmount(props.row) }}
          </span>-->
          <span v-else>{{props.row[props.column.field]}}</span>
          <span v-if="props.column.field == 'actions'">
            <b-button-group>
              <can I="manage" a="installation">
                <b-button
                  variant="primary"
                  @click="navTo(props.row.id)"
                  v-show="props.row.status == 0"
                >
                  Approve Request &nbsp;
                  <span class="fa fa-check"></span>
                </b-button>
              </can>
              <can I="update" a="installation">
                <b-button
                  size="md"
                  variant="info"
                  @click="navTo(props.row.id)"
                  v-show="props.row.status == 1"
                >
                  Approve Installation &nbsp;
                  <span class="fa fa-calendar"></span>
                </b-button>
              </can>
              <can I="manage" a="mine">
                <b-button
                  variant="primary"
                  @click="paymentOptions(props.row)"
                  v-show="props.row.status == 0"
                >
                  Make Payment &nbsp;
                  <span class="fa fa-payment"></span>
                </b-button>
                <b-button
                  variant="info"
                  @click="navTo(props.row.id)"
                  v-show="props.row.status != 0"
                >
                  Check Status &nbsp;
                  <span class="fa fa-check"></span>
                </b-button>
              </can>
            </b-button-group>
          </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
  <!-- <div class="page-content__header-description">
        <a class="btn btn-primary"  :href="productReg+`${getRegUri(getUserSession.id)}`">
              New Request &nbsp; <span class="fa fa-plus"></span>
        </a>
  </div>-->
  <!-- <div style="width: 100%;">
          <vue-good-table :columns="columns" :rows="deviceRequests" :paginate="true" :globalSearch="true" :lineNumbers="true" styleClass="table table-striped col-md-12">
          </vue-good-table>
          <b-modal centered ref="invoiceModal" hide-footer ok-disabled no-close-on-backdrop class="modal-dialog modal-content" role="document">

            <div slot="modal-header" style="text-align: center !important;">
              <b-btn class="close custom-modal__close" style="justify-content: center !important; font-size: .89em;" @click="hideModal"> <span aria-hidden="true" class="fa fa-close"></span></b-btn>
              <img src="/static/img/modal/7.png" alt="" class="">
              <h2 class="page-content__header-description">Create Invoice</h2>
            </div>

            <div class="d-block text-center">
              <b-form-input type="text" placeholder="Invoice Input" v-model="componentName"></b-form-input>
              <b-button size="md" variant="primary" style="margin-top: 12px;">
                Send Invoice &nbsp; <span class="fa fa-plus"></span>
              </b-button>
            </div>
          </b-modal>
  </div>-->
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import Rave from "vue-ravepayment";
import Fingerprint2 from "fingerprintjs2";

import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";

export default {
  name: "manage-requests",
  components: {
    Rave,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      selectedPayments: {
        setup: true
      },
      checked1: false,
      feePayable: {},
      dialogVisible: false,
      packageConfig: [],
      // TODO: Move ravekey to build env
      // raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      raveKey: "FLWPUBK_TEST-89e9c4e181bd9559a5d47e738cb3363a-X",
      raveBtnText: "Make Payment",
      packageData: null,
      selectedRow: {},
      formData: {
        expirymonth: "00",
        expiryyear: "00",
        email: "",
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        amount: 10000,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      responseData: "",
      statusMap: [
        "Pending Authorization",
        "Installation Scheduled",
        "Installation Completed"
      ],
      errors: "",
      componentName: "",
      columns: [
        {
          label: "Customer Name",
          field: "full_name"
        },
        {
          label: "Phone Number",
          field: "user.phone",
          filterable: true
        },
        // {
        //   label: 'Installation Address',
        //   field: 'address',
        //   filterable: true,
        // },
        {
          label: "Desired Bundle",
          field: "deviceType.name",
          filterable: true
        },
        {
          label: "Payment Model",
          field: "deviceType.paymentModel",
          filterable: true
        },
        // {
        //   label: "Payment Amount (₦)",
        //   field: "order.paymentAmount",
        //   filterable: true
        // },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      deviceRequests: [],
      rows: []
    };
  },
  methods: {
    getBreakDown(base, order, hasDiscount = true) {
      if (hasDiscount) {
        return {
          base: Math.round(base),
          discount: Math.round(
            order["discountType"] == "percent"
              ? (base * Number(order["orderDiscount"])) / 100
              : order["amountDiscount"]
          ),
          vat: Math.round(
            (base -
              (order["discountType"] == "percent"
                ? (base * Number(order["orderDiscount"])) / 100
                : order["amountDiscount"])) *
              (Number(order["orderVat"]) / 100)
          ),
          total: Math.round(
            base -
              (order["discountType"] == "percent"
                ? (base * Number(order["orderDiscount"])) / 100
                : order["amountDiscount"]) +
              (base -
                (order["discountType"] == "percent"
                  ? (base * Number(order["orderDiscount"])) / 100
                  : order["amountDiscount"])) *
                (Number(order["orderVat"]) / 100)
          )
        };
      } else {
        return {
          base: Math.round(base),
          discount: 0,
          vat: Math.round(base * (Number(order["orderVat"]) / 100)),
          total: Math.round(base + base * (Number(order["orderVat"]) / 100))
        };
      }
      // return {
      //   base: base,
      //   vat: base * (Number(vat) / 100),
      //   discount: base * (Number(discount) / 100),
      //   total:
      //     base + base * (Number(vat) / 100) - base * (Number(discount) / 100)
      // };
    },
    getBreakDown_(base, vat, discount) {
      return {
        base: base,
        vat: base * (Number(vat) / 100),
        discount: base * (Number(discount) / 100),
        total:
          base + base * (Number(vat) / 100) - base * (Number(discount) / 100)
      };
    },
    paymentOptions(rowData) {
      this.selectedRow = rowData;
      this.dialogVisible = true;
      let priceModel = JSON.parse(rowData.priceModel);
      if (rowData["paymentModel"] != "OS") {
        let setup = this.getBreakDown(
          Number(priceModel["setupFee"]),
          rowData,
          true
        );
        let caution = this.getBreakDown(
          Number(priceModel["cautionFee"]),
          rowData,
          false
        );
        let monthly = this.getBreakDown(
          Number(priceModel["monthlyFee"]),
          rowData,
          false
        );
        this.feePayable = {
          setup,
          caution,
          monthly
        };
      } else {
        let outright = this.getBreakDown(
          Number(priceModel["amount"]),
          rowData,
          false
        );
        this.feePayable = {
          outright
        };
      }
    },
    triggerPayment(rowData) {
      // this.selectedRow = rowData;
      // console.log(
      if (this.calculatedAmount < 1) {
        this.showErrorMsg({
          message: "You have not selected any payment"
        });
      } else {
        document.getElementById(`paymentBtn_`).click();
      }
      // );
    },
    getPrice(order, packageConfig) {
      console.log({ order, packageConfig });
      let packageType = order.deviceType;
      let cautionFee = Number(
        Number(
          Number(packageType["price"]) *
            (Number(packageConfig["Subscription"]) / 100)
        ) * Number(packageConfig["Caution"])
      ).toFixed(2);
      let subFee = Number(
        Number(packageType["price"]) *
          (Number(packageConfig["Subscription"]) / 100)
      ).toFixed(2);
      let setupFee = Number(
        Number(packageType["price"]) * (Number(packageConfig["Setup"]) / 100)
      ).toFixed(2);
      let basePrice = order.deviceType.price;
      let orderVat = order.orderVat / 100;
      let orderDiscount = order.orderDiscount / 100;
      if (order["paymentModel"] == "OS") {
        return basePrice + basePrice * orderVat - basePrice * orderDiscount;
      } else {
        return Number(
          Number(
            Number(setupFee) +
              Number(cautionFee) +
              Number(subFee) +
              Number(
                Number(packageType["price"]) * (Number(order["orderVat"]) / 100)
              )
          ) -
            Number(
              Number(packageType["price"]) *
                (Number(order["orderDiscount"]) / 100)
            )
        ).toFixed(2);
      }
    },
    // TODO:: Very important
    calculatePaymentAmount(rowData) {
      const HTTP = this.$httpUtils.instance;
      var packagData, LO_Data, ES_Data;
      // HTTP.get("/package-configs").then(packag => {
      //   packagData = packag.data;
      // });
      // for (i of packagData) {
      //   i.Package == "LO" ? (LO_Data = { ...i }) : (ES_Data = { ...i });
      // }

      ES_Data = this.packageConfig.data.find(x => x.Package == "ES");
      LO_Data = this.packageConfig.data.find(x => x.Package == "LO");

      // console.log({
      //     ES_Data,
      //     LO_Data
      // });

      let finalPrice = 0;
      let basePrice = rowData.deviceType.price;
      let orderVat = rowData.orderVat / 100;
      let orderDiscount = rowData.orderDiscount / 100;

      switch (rowData.paymentModel) {
        case "ES":
          //let price_to_pay = ((ES_Data.Setup / 100) * basePrice) + ((ES_Data.Subscription / 100) * basePrice) + (ES_Data.Subscription * ES_Data.Caution)
          finalPrice = this.getPrice(rowData, ES_Data);
          // finalPrice =
          //     (ES_Data.Setup / 100) * basePrice +
          //     (ES_Data.Subscription / 100) * basePrice +
          //     ES_Data.Subscription * ES_Data.Caution;
          break;
        case "LO":
          finalPrice = this.getPrice(rowData, LO_Data);
          //     finalPrice =
          //       (ES_Data.Setup / 100) * basePrice +
          //       (ES_Data.Subscription / 100) * basePrice +
          //       ES_Data.Subscription * ES_Data.Caution;

          break;
        default:
          finalPrice = this.getPrice(rowData, {});
          break;
      }
      return finalPrice;
      // return {
      //   basePrice,
      //   orderVat,
      //   orderDiscount
      // };
    },
    callback: async function(response) {
      let trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      // console.log(trRef.data);
      if (trRef.data.status === "successful") {
        this.transDone = true;
      } else {
        this.showErrorMsg({
          message: "Transaction fails"
        });
      }
      // this.transComplete = await this.concludeTransaction(
      //   trRef.data.txRef,
      //   this.selectedRow.id
      // );
      this.close;
    },
    close: function() {
      console.log("Payment closed");
    },
    async concludeTransaction(txRef, requestId) {
      var data = true;
      var str = JSON.stringify({
        txref: txRef,
        requestId: requestId
      });
      const tempReg = JSON.parse(str);
      const HTTP = this.$httpUtils.instance;
      const url = "/payments/initial/request";
      return HTTP.post(url, tempReg)
        .then(response => {
          this.myResponse = response.data.data[0];
          // console.log(response.data.data[0]);
          data = true;
          return true;
        })
        .catch(error => {
          console.log(error);
          var errorMsg = error.response.data.message;
          this.showErrorMsg({
            message: errorMsg
          });
          return false;
        });
      return data;
    },
    getRegUri(data) {
      return Base64.encode(`�6` + data);
    },
    getRegLink(link) {
      return link + this.getUserSession.loggegInUser.token;
    },
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal() {
      this.$refs.invoiceModal.hide();
    },
    navTo(id) {
      this.$router.push({
        name: "deviceRequestStatus",
        params: {
          id: id
        }
      });
    }
  },
  computed: {
    ...mapGetters(["getUserById", "getDummy", "getUserSession"]),
    paymentMeta() {
      return {
        ...this.selectedRow,
        selectedPayments: this.selectedPayments,
        type: "initial"
      };
    },
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    },
    calculatedAmount() {
      return Object.keys(this.selectedPayments).reduce((x, ind_) => {
        return (x +=
          this.selectedPayments[ind_] == true && this.feePayable[ind_]
            ? this.feePayable[ind_]["total"]
            : 0);
      }, 0);
    }
    // productReg: {
    //   get(){
    //     return this._productReg+ this.getUserSession.loggedInUser.token;
    //   },
    //   set(val){
    //     // this.productReg = this.productReg+ this.getUserSession.loggedInUser.token;
    //   }
    // }
  },
  watch: {
    // selectedPayments:function(val){
    //   console.log(val);
    // Object.keys(selectedPayments).reduce((sum,index)=>{
    //         sum+=feePayable[x]['total'];
    //         return sum;
    //       },0)
    // }
  },
  async mounted() {
    const HTTP = this.$httpUtils.instance;
    const container = this;
    let userId = this.getUserSession.id;
    let realm = this.getUserSession.realm;
    let fp = Fingerprint2();
    this.formData = {
      ...this.formData,
      firstname: this.getUserSession.firstName,
      lastname: this.getUserSession.lastName,
      email: this.getUserSession.email,
      phonenumber: this.getUserSession.phoneNumber,
      name: `${this.getUserSession.firstName} ${this.getUserSession.lastName}`
    };
    fp.get(function(result, components) {
      container.formData.deviceFingerprint = result; // a hash, representing your device fingerprint
      container.formData.device_fingerprint = {
        result,
        components
      }; // an array of FP components
    });
    // console.log({ formData: this.formData });

    this.packageConfig = await HTTP.get("/package-configs");
    //  .then(packag => {
    //     packagData = packag.data;
    //   });
    HTTP.get(
      `/device_requests/?filter={"include": ["user","transactionHistories",{"deviceType": { "packageComponents": "componentType" }}], "where": {"and":[{"userId":${userId}}, {"or":[{"status": 0},{"status": 1},{"status": 2},{"status": 3},{"status": 4}]}]}}`,
      {}
    ).then(response => {
      // console.log(response)
      // console.log(JSON.stringify(rolesdata.data))
      container.deviceRequests = response.data.filter(x => x.user);
    });
  }
};
</script>

<style>
.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
.requests-table-height {
  height: calc(100vh - 280px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/MyRequests.vue